import { render } from "./BlogComponent.vue?vue&type=template&id=3b602c12&scoped=true"
import script from "./BlogComponent.vue?vue&type=script&lang=js"
export * from "./BlogComponent.vue?vue&type=script&lang=js"

import "./BlogComponent.vue?vue&type=style&index=0&id=3b602c12&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b602c12"]])

export default __exports__